// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"934b0129","670":"63762c73","899":"354c79c2"}[chunkId] + ".chunk.js";
};